module.exports = __webpack_public_path__ + "img/about-i@2x.84f6bb96.png";